module.exports = __webpack_public_path__ + "static/media/Circo2025_19.f325ff39.webp";